var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoPlayCoreButtonV4 = function SvgVideoPlayCoreButtonV4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.3,
    stroke: "#323338",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323338",
    d: "M23.833 15.134a1 1 0 0 1 0 1.732l-11 6.35a1 1 0 0 1-1.5-.865V9.649a1 1 0 0 1 1.5-.866z"
  })));
};
export default SvgVideoPlayCoreButtonV4;